interface Props {
    width?: number;
    height?: number;
    hexColor?: string;
    fill?: boolean;
    title?: string;
}

export const HeartIcon = ({
    width = 19,
    height = 15,
    hexColor = 'black',
    fill = false,
    title = 'Lista želja'
}: Props) => {
    return (
        <svg width={width} height={height} viewBox="0 0 19 15" fill={fill ? hexColor : 'none'} xmlns="http://www.w3.org/2000/svg">
            <title>{title}</title>
            <path d="M9.5 14C9.5 14 1 9.92731 1 5.04002C1 0.152744 7.61111 -0.254527 9.5 3.56929C11.3889 -0.254527 18 0.152744 18 5.04002C18 9.92731 9.5 14 9.5 14Z" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        
    );
};

export default HeartIcon;
